var map = {
	"./allocate.svg": 27876,
	"./archive.svg": 7687,
	"./arrow-down.svg": 81953,
	"./arrow-left.svg": 29586,
	"./arrow-right.svg": 32527,
	"./arrow-up.svg": 14334,
	"./bookmark.svg": 69801,
	"./calendar.svg": 91103,
	"./cancel.svg": 49643,
	"./caret-down.svg": 34839,
	"./caret-left.svg": 91016,
	"./caret-right.svg": 93405,
	"./caret-up.svg": 9936,
	"./cart.svg": 27719,
	"./check-circle.svg": 61940,
	"./check-in.svg": 33157,
	"./check-out.svg": 76158,
	"./chevron-double-left.svg": 66000,
	"./chevron-double-right.svg": 46693,
	"./chevron-left.svg": 82708,
	"./chevron-right.svg": 43393,
	"./clipboard.svg": 63511,
	"./clock.svg": 48511,
	"./combine.svg": 56678,
	"./comment.svg": 54842,
	"./dash.svg": 87245,
	"./default.svg": 82530,
	"./deselect-all.svg": 2614,
	"./diacritic.svg": 9371,
	"./document.svg": 73654,
	"./download.svg": 86265,
	"./drag-drop.svg": 80117,
	"./duplicate.svg": 35294,
	"./edit.svg": 45813,
	"./ellipsis.svg": 760,
	"./end-mark.svg": 51142,
	"./envelope.svg": 98461,
	"./exclamation-circle.svg": 16385,
	"./external-link.svg": 42591,
	"./eye-closed.svg": 42145,
	"./eye-open.svg": 73241,
	"./flag.svg": 68083,
	"./gear.svg": 8296,
	"./graph.svg": 78325,
	"./house.svg": 79029,
	"./indexes.svg": 12670,
	"./info.svg": 94493,
	"./lightning.svg": 66723,
	"./link.svg": 76857,
	"./list.svg": 34094,
	"./lock.svg": 27268,
	"./number-generator.svg": 46950,
	"./play.svg": 72131,
	"./plus-sign.svg": 8179,
	"./preview.svg": 65685,
	"./print.svg": 74212,
	"./profile.svg": 79994,
	"./question-mark.svg": 74367,
	"./receive.svg": 91298,
	"./refresh.svg": 22000,
	"./replace.svg": 35697,
	"./report.svg": 92075,
	"./save.svg": 92258,
	"./search.svg": 3165,
	"./select-all.svg": 36859,
	"./source.svg": 13850,
	"./tag.svg": 21513,
	"./times-circle-solid.svg": 20180,
	"./times-circle.svg": 27506,
	"./times.svg": 36535,
	"./transfer.svg": 72120,
	"./trash.svg": 89147,
	"./triangle-down.svg": 60340,
	"./triangle-up.svg": 54855,
	"./unlink.svg": 9364,
	"@folio/stripes-components/lib/Icon/icons/allocate.svg": 27876,
	"@folio/stripes-components/lib/Icon/icons/archive.svg": 7687,
	"@folio/stripes-components/lib/Icon/icons/arrow-down.svg": 81953,
	"@folio/stripes-components/lib/Icon/icons/arrow-left.svg": 29586,
	"@folio/stripes-components/lib/Icon/icons/arrow-right.svg": 32527,
	"@folio/stripes-components/lib/Icon/icons/arrow-up.svg": 14334,
	"@folio/stripes-components/lib/Icon/icons/bookmark.svg": 69801,
	"@folio/stripes-components/lib/Icon/icons/calendar.svg": 91103,
	"@folio/stripes-components/lib/Icon/icons/cancel.svg": 49643,
	"@folio/stripes-components/lib/Icon/icons/caret-down.svg": 34839,
	"@folio/stripes-components/lib/Icon/icons/caret-left.svg": 91016,
	"@folio/stripes-components/lib/Icon/icons/caret-right.svg": 93405,
	"@folio/stripes-components/lib/Icon/icons/caret-up.svg": 9936,
	"@folio/stripes-components/lib/Icon/icons/cart.svg": 27719,
	"@folio/stripes-components/lib/Icon/icons/check-circle.svg": 61940,
	"@folio/stripes-components/lib/Icon/icons/check-in.svg": 33157,
	"@folio/stripes-components/lib/Icon/icons/check-out.svg": 76158,
	"@folio/stripes-components/lib/Icon/icons/chevron-double-left.svg": 66000,
	"@folio/stripes-components/lib/Icon/icons/chevron-double-right.svg": 46693,
	"@folio/stripes-components/lib/Icon/icons/chevron-left.svg": 82708,
	"@folio/stripes-components/lib/Icon/icons/chevron-right.svg": 43393,
	"@folio/stripes-components/lib/Icon/icons/clipboard.svg": 63511,
	"@folio/stripes-components/lib/Icon/icons/clock.svg": 48511,
	"@folio/stripes-components/lib/Icon/icons/combine.svg": 56678,
	"@folio/stripes-components/lib/Icon/icons/comment.svg": 54842,
	"@folio/stripes-components/lib/Icon/icons/dash.svg": 87245,
	"@folio/stripes-components/lib/Icon/icons/default.svg": 82530,
	"@folio/stripes-components/lib/Icon/icons/deselect-all.svg": 2614,
	"@folio/stripes-components/lib/Icon/icons/diacritic.svg": 9371,
	"@folio/stripes-components/lib/Icon/icons/document.svg": 73654,
	"@folio/stripes-components/lib/Icon/icons/download.svg": 86265,
	"@folio/stripes-components/lib/Icon/icons/drag-drop.svg": 80117,
	"@folio/stripes-components/lib/Icon/icons/duplicate.svg": 35294,
	"@folio/stripes-components/lib/Icon/icons/edit.svg": 45813,
	"@folio/stripes-components/lib/Icon/icons/ellipsis.svg": 760,
	"@folio/stripes-components/lib/Icon/icons/end-mark.svg": 51142,
	"@folio/stripes-components/lib/Icon/icons/envelope.svg": 98461,
	"@folio/stripes-components/lib/Icon/icons/exclamation-circle.svg": 16385,
	"@folio/stripes-components/lib/Icon/icons/external-link.svg": 42591,
	"@folio/stripes-components/lib/Icon/icons/eye-closed.svg": 42145,
	"@folio/stripes-components/lib/Icon/icons/eye-open.svg": 73241,
	"@folio/stripes-components/lib/Icon/icons/flag.svg": 68083,
	"@folio/stripes-components/lib/Icon/icons/gear.svg": 8296,
	"@folio/stripes-components/lib/Icon/icons/graph.svg": 78325,
	"@folio/stripes-components/lib/Icon/icons/house.svg": 79029,
	"@folio/stripes-components/lib/Icon/icons/indexes.svg": 12670,
	"@folio/stripes-components/lib/Icon/icons/info.svg": 94493,
	"@folio/stripes-components/lib/Icon/icons/lightning.svg": 66723,
	"@folio/stripes-components/lib/Icon/icons/link.svg": 76857,
	"@folio/stripes-components/lib/Icon/icons/list.svg": 34094,
	"@folio/stripes-components/lib/Icon/icons/lock.svg": 27268,
	"@folio/stripes-components/lib/Icon/icons/number-generator.svg": 46950,
	"@folio/stripes-components/lib/Icon/icons/play.svg": 72131,
	"@folio/stripes-components/lib/Icon/icons/plus-sign.svg": 8179,
	"@folio/stripes-components/lib/Icon/icons/preview.svg": 65685,
	"@folio/stripes-components/lib/Icon/icons/print.svg": 74212,
	"@folio/stripes-components/lib/Icon/icons/profile.svg": 79994,
	"@folio/stripes-components/lib/Icon/icons/question-mark.svg": 74367,
	"@folio/stripes-components/lib/Icon/icons/receive.svg": 91298,
	"@folio/stripes-components/lib/Icon/icons/refresh.svg": 22000,
	"@folio/stripes-components/lib/Icon/icons/replace.svg": 35697,
	"@folio/stripes-components/lib/Icon/icons/report.svg": 92075,
	"@folio/stripes-components/lib/Icon/icons/save.svg": 92258,
	"@folio/stripes-components/lib/Icon/icons/search.svg": 3165,
	"@folio/stripes-components/lib/Icon/icons/select-all.svg": 36859,
	"@folio/stripes-components/lib/Icon/icons/source.svg": 13850,
	"@folio/stripes-components/lib/Icon/icons/tag.svg": 21513,
	"@folio/stripes-components/lib/Icon/icons/times-circle-solid.svg": 20180,
	"@folio/stripes-components/lib/Icon/icons/times-circle.svg": 27506,
	"@folio/stripes-components/lib/Icon/icons/times.svg": 36535,
	"@folio/stripes-components/lib/Icon/icons/transfer.svg": 72120,
	"@folio/stripes-components/lib/Icon/icons/trash.svg": 89147,
	"@folio/stripes-components/lib/Icon/icons/triangle-down.svg": 60340,
	"@folio/stripes-components/lib/Icon/icons/triangle-up.svg": 54855,
	"@folio/stripes-components/lib/Icon/icons/unlink.svg": 9364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73561;